export default class StringUtils {
  static capitalize(s: any) {
    if (typeof s !== "string") {
      return "";
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
}
